import { render, staticRenderFns } from "./CoursewareShelfActionWidget.vue?vue&type=template&id=bed83862&"
import script from "./CoursewareShelfActionWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareShelfActionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports